<template>
    <b-card
        header-tag="header"
    >
        <template #header>
            <h4>Detalhes da mesa Nº {{id}}</h4>
        </template>

        <div class="row mb-2">
            <div class="col-md-4">
                <font-awesome-icon icon="users" /> Valor Total: <strong class="text-uppercase" > {{mesa[0].valor_total_mesa}} </strong>
            </div>
            <div class="col-md-4">
                <font-awesome-icon icon="users" /> Desconto Total: <strong class="text-uppercase" > {{mesa[0].desconto_total_mesa}} </strong>
            </div>
            <div class="col-md-4">
                <font-awesome-icon icon="users" /> Acrescimo Total: <strong class="text-uppercase" > {{mesa[0].acrescimo_total_mesa}} </strong>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4">
                <font-awesome-icon icon="users" /> Hora Último: <strong class="text-uppercase" > {{mesa[0].hora}} </strong>
            </div>
            <div class="col-md-8">
                <font-awesome-icon icon="users" /> Último produto: <strong class="text-uppercase" > {{mesa[0].produto}} </strong>
            </div>
        </div>
        
        <hr>

        <b-table
            striped
            hover
            :items="mesa"
            head-variant="dark"
            small
            outlined
            bordered
            responsive
            class="text-uppercase"
            :fields="['produto', 'valor_unitario', 'quantidade', 'valor_total', 'desconto', 'acrescimo', 'hora']"
        />
    </b-card>
</template>
<script>
    export default {
        name: 'mesasDetalhe',
        data(){
            return {
                mesa: [{}]
            }
        },

        computed: {
            getToken(){
                return this.$store.getters.getToken
            },

            id(){
                return this.$route.params.id
            }
        },

        methods: {
			getData: function(){
				fetch(server + 'informacoes/mesas/' + this.id , {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
				})
					.then(response => {
                        if(response.status == 200){
                            response.json()
                                .then(data => {
                                    if(data.data){
                                        if(data.response.length > 0) {
                                            let res = data.response

                                            res.forEach(element => {
                                                element.hora = this.$moment(element.hora, 'DD-MM-YYYY HH:mm:ss').format('LTS')
                                            });

                                            this.mesa = res
                                        }
                                    }else{
                                        console.error('Error exception', '=>', data.message)
                                    }
                                })
                                .catch(error => {
                                    console.error('Error exception', '=>', error.message)
                                })
                        }else{
                            console.error('Error exception', '=>', response.statusText)
                        }
					})
					.catch(error => {
						console.error('Error exception', '=>', error.message)
					})
			}
        },

        mounted(){
            this.getData()
        }
    }
</script>